<template>
  <a-select
    v-model:value="value"
    placeholder="请选择职级别"
    style="width: 100%"
    @popupScroll="fetchUser"
  >
   <a-select-option :value="v.id" v-for="v in data " :key="v.id">{{v.rank_name}}</a-select-option>
    <template v-if="fetching" #notFoundContent>
      <a-spin size="small" />
    </template>
  </a-select>
</template>
<script>
import { defineComponent, onMounted, reactive, toRefs, watch } from 'vue';
import { debounce } from 'lodash-es';
import {getBrandSaleRank} from '@/api/salesman'
export default defineComponent({
    name:"rankSelect",
  setup(props,{emit}) {
    let lastFetchId = 0;
    const state = reactive({
      data: [],
      value: '',
      fetching: false,
      done:false,
      search:{
          page:1,
          limit:10
      }
    });
    const fetchUser = debounce(async() => {
        if(state.done)return
        state.fetching=true
        let result=await getBrandSaleRank(state.search).then(res=>res.data).catch(error=>error)
        state.fetching=false
        state.search.page+=1
        state.data=state.data.concat(result.data.data)  
        if(state.data.length==result.data.total){
            state.done=true
        }
    }, 300);
    onMounted(()=>{
        fetchUser()
    })
    watch(state.value, () => {
      state.data = [];
      state.fetching = false;
      emit("update:value",state.value)
    });
    return { ...toRefs(state), fetchUser };
  },
});
</script>